export enum ReportsSalesQuarter {
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
}

export const ReportsSalesQuarterTranslate: Record<number, string> = {
  [ReportsSalesQuarter.ONE]: '1',
  [ReportsSalesQuarter.TWO]: '2',
  [ReportsSalesQuarter.THREE]: '3',
  [ReportsSalesQuarter.FOUR]: '4',
};

export const plan_quarter = Object.keys(ReportsSalesQuarterTranslate).map((f: string) => ({
  text: ReportsSalesQuarterTranslate[parseInt(f, 10)],
  value: parseInt(f, 10),
}));

export enum ReportsTypes {
  REPORT_ORDER = 'report_order',
  REPORT_SALES = 'report_sales',
  REPORT_ON_MUTUAL_SETTLEMENTS = 'report_on_mutual_settlements',
  REPORT_RESULT_SERVICE_ACTIVITIES = 'report_result_service_activities',
  REPORT_REPAIR_BY_PERIOD = 'report_repair_by_period',
}

export const ReportsTypesTranslate: Record<string, string> = {
  [ReportsTypes.REPORT_ORDER]: 'reports/orders',
  [ReportsTypes.REPORT_SALES]: 'reports/sales',
  [ReportsTypes.REPORT_ON_MUTUAL_SETTLEMENTS]: 'reports/mutual',
  [ReportsTypes.REPORT_RESULT_SERVICE_ACTIVITIES]: 'reports/service',
  [ReportsTypes.REPORT_REPAIR_BY_PERIOD]: 'reports/repairs',
};

export enum ReportOrderTypes {
  SHIPPED = 'shipped',
  NOT_SHIPPED = 'not_shipped',
  CANCELED = 'canceled',
  READY_SHIPPED = 'ready_shipped'
}
